/* =================================================================
   br-card-carousel — arrow navigation for the scroll-snap viewport.

   Re-implements the donor's Webflow Slider arrows in vanilla JS:
   one card per click, smooth scroll, wrap-around at the ends (the
   donor loops infinitely). Manual only — no auto-scroll (Kelly,
   2026-07-23). Honors prefers-reduced-motion.
   ================================================================= */
(function () {
  var sections = document.querySelectorAll('.br-card-carousel');

  sections.forEach(function (section) {
    var viewport = section.querySelector('[data-carousel-viewport]');
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    if (!viewport || !prev || !next) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function cardStep() {
      var card = viewport.querySelector('.br-card-carousel__card');
      if (!card) return viewport.clientWidth;
      var gap =
        parseFloat(getComputedStyle(viewport.querySelector('.br-card-carousel__track')).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByCard(direction) {
      var step = cardStep() * direction;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var behavior = reduceMotion.matches ? 'auto' : 'smooth';

      /* Wrap around only when already AT an end — the donor loops
         infinitely. (Landing on 0 is a valid position, not a wrap.) */
      if (direction > 0 && viewport.scrollLeft >= maxScroll - 1) {
        viewport.scrollTo({ left: 0, behavior: behavior });
        return;
      }
      if (direction < 0 && viewport.scrollLeft <= 1) {
        viewport.scrollTo({ left: maxScroll, behavior: behavior });
        return;
      }
      viewport.scrollBy({ left: step, behavior: behavior });
    }

    prev.addEventListener('click', function () {
      scrollByCard(-1);
    });
    next.addEventListener('click', function () {
      scrollByCard(1);
    });
  });
})();
